export default "__VITE_ASSET__C1WDc1_1__"